import ExistingPolicyInformation from '../../ExistingPolicyInformation';
import PrimaryInsuredInfo from '../../PrimaryInsuredInfo';
import AgentInformation from '../../AgentInformation';
import InForceLedger from './InForceLedger';
import Submit from './Submit';
import FileUpload from './FileUpload';

export {
    PrimaryInsuredInfo,
    ExistingPolicyInformation,
    AgentInformation,
    Submit,
    InForceLedger,
    FileUpload
}


// WEBPACK FOOTER //
// ./src/components/PolicyReview/PermReview/steps/index.js